import { Component, type ErrorInfo, type ReactNode } from 'react'
import { loadSentry } from '../lib/sentry'

export function ErrorFallback() {
  return (
    <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: '-apple-system, sans-serif' }}>
      <div style={{ maxWidth: 360, textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Something went wrong</h1>
        <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 20 }}>
          We've logged the issue. Please try again.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{ background: '#111827', color: 'white', border: 'none', borderRadius: 10, padding: '12px 24px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
        >
          Reload
        </button>
      </div>
    </div>
  )
}

export default class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    void loadSentry()?.then(Sentry => {
      Sentry.captureException(error, {
        contexts: {
          react: { componentStack: errorInfo.componentStack },
        },
      })
    })
  }

  render() {
    return this.state.hasError ? <ErrorFallback /> : this.props.children
  }
}
